<template>
    <div class="learn">
        <el-form :model="searchData" :inline="true" size="small">
            <el-form-item>
                <el-input v-model="searchData.subject" placeholder="题目" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-select v-model="searchData.question_type_id" placeholder="类型" clearable>
                    <el-option
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        v-for="item in typeData.list"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" plain icon="el-icon-search" @click="GetSearch"
                    >搜索</el-button
                >
            </el-form-item>
        </el-form>
        <div class="card">
            <div class="list" v-loading="questionData.loading.list">
                <el-row class="list-control">
                    <el-col :span="24" class="t-right">
                        <el-tooltip effect="dark" content="请勿修改模板文件结构" placement="top">
                            <el-button size="small" @click="TemplateQuestion">模板</el-button>
                        </el-tooltip>
                        <el-upload
                            action=""
                            :show-file-list="false"
                            :http-request="ImportQuestion"
                            class="list-upload"
                        >
                            <el-button size="small">导入</el-button>
                        </el-upload>
                        <el-button
                            type="primary"
                            size="small"
                            icon="el-icon-circle-plus"
                            @click="DetailQuestion"
                            >题目</el-button
                        >
                    </el-col>
                </el-row>
                <div class="list-table">
                    <el-table :data="questionData.list" stripe style="width: 100%">
                        <el-table-column prop="subject" label="题目"></el-table-column>
                        <el-table-column
                            prop="question_type"
                            label="类型"
                            width="60"
                        ></el-table-column>
                        <el-table-column label="分值" width="60">
                            <template slot-scope="scope">{{ scope.row.score }} 分</template>
                        </el-table-column>
                        <el-table-column
                            prop="updated_at"
                            label="更新时间"
                            width="180"
                        ></el-table-column>
                        <el-table-column width="120" fixed="right">
                            <template slot-scope="scope">
                                <div class="t-right">
                                    <el-link
                                        type="primary"
                                        :underline="false"
                                        @click="DetailQuestion(scope.row)"
                                        >修改</el-link
                                    >
                                    <el-divider direction="vertical"></el-divider>
                                    <el-link
                                        type="primary"
                                        :underline="false"
                                        @click="DelQuestion(scope.row)"
                                        >删除</el-link
                                    >
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="list-pagination">
                    <el-pagination
                        background
                        layout="total, prev, pager, next, sizes"
                        :current-page.sync="questionData.pages.page"
                        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]"
                        :page-size="questionData.pages.pagesize"
                        :total="questionData.pages.total"
                        @size-change="GetSize"
                        @current-change="GetCurrent"
                    ></el-pagination>
                </div>
            </div>
        </div>

        <v-questionData
            :detailParam="componentParam.questionForm"
            v-if="componentParam.questionForm.visible"
        />
    </div>
</template>

<script>
import questionData from '@/components/question/Form'
import { LearnData } from '@/plugin/Learn'
export default {
    components: {
        'v-questionData': questionData
    },
    inject: ['reload'],
    mixins: [LearnData],
    data() {
        return {
            typeData: {
                list: []
            },
            searchData: {
                subject: null,
                question_type_id: null
            },
            questionData: {
                loading: {
                    list: false
                },
                list: [],
                pages: {
                    page: 1,
                    pagesize: 10,
                    total: 0
                }
            },
            componentParam: {
                questionForm: {}
            }
        }
    },
    created() {
        this.$nextTick(() => {
            this.GetType()
        })
    },
    mounted() {
        this.$nextTick(() => {
            this.GetQuestion()
        })
    },
    methods: {
        GetSearch() {
            this.questionData.pages.page = 0
            this.GetQuestion()
        },
        // 类型列表
        GetType() {
            // 类型
            this.GetTypeData({
                data: {
                    order: 'ASC'
                }
            }).then(res => {
                this.typeData.list = res.list
            })
        },
        // 题库列表
        GetQuestion() {
            this.questionData.loading.list = true
            this.$request({
                url: '/api/v1/question',
                params: {
                    ...this.searchData,
                    ...this.questionData.pages
                }
            }).then(res => {
                if (!res.status) {
                    this.questionData.loading.list = false
                    this.questionData.list = res.data.list
                    this.questionData.pages.total = parseInt(res.data.total)
                } else {
                    this.$message.error(res.message || '操作失败')
                }
            })
        },
        GetSize(val) {
            this.questionData.pages.pagesize = val
            this.GetQuestion()
        },
        GetCurrent(val) {
            this.questionData.pages.page = val
            this.GetQuestion()
        },
        // 模板下载
        TemplateQuestion() {
            window.location.href = '/question.xlsx'
        },
        // 批量导入
        ImportQuestion(obj) {
            var requestData = new FormData()
            requestData.append('file', obj.file)
            this.$request({
                url: '/api/v1/uploadQuestionImport',
                method: 'POST',
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                data: requestData
            }).then(res => {
                this.$message({
                    message: res.message || (res.status ? '操作失败' : '操作成功'),
                    type: res.status ? 'error' : 'success'
                })
                if (!res.status) {
                    this.reload()
                }
            })
        },
        // 详情 增加&修改
        DetailQuestion(row) {
            this.componentParam.questionForm = {
                visible: true,
                row: {
                    id: row.id
                }
            }
        },
        DelQuestion(row) {
            this.$confirm('此操作将永久删除当前数据, 是否继续?', '警告', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.$request({
                        url: '/api/v1/question_del',
                        params: {
                            id: row.id
                        }
                    }).then(res => {
                        this.$message({
                            message: res.message || (res.status ? '操作失败' : '操作成功'),
                            type: res.status ? 'error' : 'success'
                        })
                        if (!res.status) {
                            this.reload()
                        }
                    })
                })
                .catch(() => {})
        }
    }
}
</script>

<style scoped lang="less">
@import '~@/assets/css/card.less';
@import '~@/assets/css/list.less';
</style>
